import modes from 'constants/modes';
import recurTypes from 'constants/recur-types';
import notifyBeforeTypes from 'constants/notify-before-types';
import eventStatuses from 'constants/event-statuses';
import fieldIndices from './field-indices';

import {
  storeEventTemplateValuesToFieldValue,
  formatToUTCDateTime,
  validateRecurType,
  calculateNotifyBeforeInSeconds
} from '../../utilities';

export function getDefaultValues() {

  return ['', '', '', '', '', '', '', 0];

}

export function isEditorDisabled(rootState) {

  return rootState.mode === modes.READ;

}

export function getNotifyBeforeOptions() {

  const notifyBeforeOptions = [{
    label: 'Before 1 hour',
    value: notifyBeforeTypes.HOUR
  }, {
    label: 'Before 1 day',
    value: notifyBeforeTypes.DAY
  }, {
    label: 'Before 1 week',
    value: notifyBeforeTypes.WEEK
  }];

  return notifyBeforeOptions;

}

export function getEditorMode(event) {

  if (event.status === void 0) {
    return modes.WRITE;
  }

  if (event.status !== eventStatuses.CREATED) {
    return modes.READ;
  }

  if (event.startTime === 0) {
    return modes.WRITE;
  }

  const currentTimePlus60Seconds = (Date.now() + (60 * 1000));

  if (event.startTime > currentTimePlus60Seconds) {
    return modes.WRITE;
  }

  return modes.READ;

}

export function valuesToJSON(rootState, values) {

  if (rootState.event === null) {
    return {};
  }

  const startDateAndTime = formatToUTCDateTime(values[0], values[1]);
  const endDateAndTime = formatToUTCDateTime(values[2], values[3]);

  const options = {
    formattedStartDate: startDateAndTime.date,
    formattedStartTime: startDateAndTime.time,
    formattedEndDate: endDateAndTime.date,
    formattedEndTime: endDateAndTime.time,
    recurType: values[4],
    location: {
      ...rootState.event.location,
      type: values[5],
      value: values[6]
    },
    notifyBeforeInSeconds: calculateNotifyBeforeInSeconds(values[7])
  };

  return options;

}

export function setEventFieldsInForm(event, setValueByIndex) {

  storeEventTemplateValuesToFieldValue(event, setValueByIndex);

}

export function setEditorMode(setRootState, mode) {

  setRootState(function updateRootState(rootState) {

    return {
      ...rootState,
      mode
    };

  });

}

export function trySetErrorMessages(errorMessages, forceDisplayErrors, setErrorMessages, setRootState) {

  if (errorMessages.length === 0) {
    return setEditorMode(setRootState, modes.READ);
  }

  return setErrorMessages(errorMessages, forceDisplayErrors);

}

export function exceptionToErrorMessages(exception) {

  if (exception.code === 'STARTUP_EVENT_MUST_BE_EDITABLE') {
    return [];
  }

  const errorMessages = ['', '', '', '', '', '', '', ''];
  const metadata = exception.metadata;

  for (let error of metadata) {

    if (error.instancePath.indexOf('formattedStartDate') !== -1) {
      errorMessages[fieldIndices.START_DATE_INDEX] = 'Please select today or later date';
    } else if (error.instancePath.indexOf('formattedStartTime') !== -1) {
      errorMessages[fieldIndices.START_TIME_INDEX] = 'Start time must be one hour more than current time';
    } else if (error.instancePath.indexOf('formattedEndDate') !== -1) {
      errorMessages[fieldIndices.END_DATE_INDEX] = 'End date must be same or later than Start date';
    } else if (error.instancePath.indexOf('formattedEndTime') !== -1) {
      errorMessages[fieldIndices.END_TIME_INDEX] = 'End time must be 30 minutes more than start time';
    } else if (error.instancePath.indexOf('notifyBeforeInSeconds') !== -1) {
      errorMessages[fieldIndices.NOTIFY_BEFORE_INDEX] = 'Please select available duration from start time';
    } else if (error.instancePath.indexOf('location/value') !== -1) {
      errorMessages[fieldIndices.LOCATION_VALUE_INDEX] = 'Please enter at least 3 letters';
    }

  }

  return errorMessages;

}

export function getRecurTypeOptions(fieldValues) {

  const result = validateRecurType({
    dateDetails: {
      formattedStartDate: fieldValues[0],
      formattedStartTime: fieldValues[1],
      formattedEndDate: fieldValues[2],
      formattedEndTime: fieldValues[3]
    },
    recurType: fieldValues[4]
  });

  const recurTypeOptions = [{
    label: 'No Repeat',
    value: recurTypes.NO_REPEAT
  }, {
    label: 'Daily',
    value: recurTypes.DAILY
  }, {
    label: 'Weekly',
    value: recurTypes.WEEKLY
  }, {
    label: 'Monthly',
    value: recurTypes.MONTHLY
  }];
  const validRecurTypes = result.validRecurTypes;
  const options = [];

  for (let recurTypeOption of recurTypeOptions) {

    options.push({
      ...recurTypeOption,
      disabled: validRecurTypes.indexOf(recurTypeOption.value) === -1
    });

  }

  return options;

}